export default __webpack_public_path__ + "static/media/google.c41e9ad6.png";